// src/components/plan/PlanNotice.jsx
// Pooled inbox SP5, owner item 20 (proposed, Wording pending): one notice at
// the top of the client's dashboard while chat is closed or a payment failed,
// read from the verified user's entitlement — never paid → choose a plan;
// lapsed → choose a plan again; a failed payment (past_due: chat stays open
// through Stripe's retries, owner item 4) → update the card (an App Store
// client's card is Apple's: Profile, where the App Store button is). The
// dashboard is legacy and light, so the notice takes the page's own tokens.
import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext.jsx";
import { Button } from "../ui";
import {
  CHOOSE_PLAN_PATH,
  hasChatAccess,
} from "../../shared/_helpers/chatGate";
import { PLAN_CARD_PATH } from "./planNav";
import {
  APPLE_PAST_DUE_NOTE,
  MANAGE_IN_APP_STORE,
  NOTICE_CHOOSE_PLAN,
  NOTICE_LAPSED,
  NOTICE_NEVER_PAID,
  NOTICE_PAYMENT_FAILED,
  NOTICE_UPDATE_CARD,
} from "./planCopy";

const noticeFor = (user) => {
  const { entitlement } = user;
  if (entitlement.state === "past_due")
    return entitlement.source === "apple"
      ? [APPLE_PAST_DUE_NOTE, "/profile", MANAGE_IN_APP_STORE]
      : [NOTICE_PAYMENT_FAILED, PLAN_CARD_PATH, NOTICE_UPDATE_CARD];
  if (hasChatAccess(user)) return null;
  if (entitlement.state === "ended")
    return [NOTICE_LAPSED, CHOOSE_PLAN_PATH, NOTICE_CHOOSE_PLAN];
  return [NOTICE_NEVER_PAID, CHOOSE_PLAN_PATH, NOTICE_CHOOSE_PLAN];
};

export default function PlanNotice() {
  const { user } = useAuth();
  if (user?.userType !== "client" || !user.entitlement) return null;
  const notice = noticeFor(user);
  if (!notice) return null;
  const [text, to, action] = notice;
  return (
    <div
      role="status"
      className="tw-mb-4 tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-3 tw-rounded-lg tw-border tw-border-solid tw-border-divider tw-bg-surface tw-px-6 tw-py-4 tw-font-sans tw-text-text"
    >
      <p className="tw-m-0 tw-text-sm tw-text-text">{text}</p>
      <Button as={Link} to={to} size="sm" className="tw-min-h-11">
        {action}
      </Button>
    </div>
  );
}
